import { useContext, useState, useEffect } from "react";
import CalendarsContext from "../../../../context/NewCalendarContext/CalendarsContext";
import { closeListUserSchedule } from "../../../../context/NewCalendarContext/Actions";
import { GET_TIMECHECKER_EXPORT, GET_TIMECHECKER_OPT } from "../../../../Querys/querys";
import { useLazyQuery } from "@apollo/client";
import {
  Dialog,
  DialogContent,
  Select,
  TextField,
} from "@material-ui/core";
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import TableBits from "../../../TableBits/TableBits";
import { TBColumn } from "../../../../interfaces/TableBits.interfaces";
import '../../ClockCalendar.css';
import { ErrorAlert } from "../../../../alerts/errorAlert";
import {
  format, addMonths, subMonths, addDays,
  isAfter, isBefore, isEqual
} from "date-fns";
import { es } from 'date-fns/locale';
import { CreateExcelRelogChecador } from './ExcelRelojReport';

/* ==============================
   COLUMNAS TABLA
   ============================== */
const columns: TBColumn[] = [
  { id: "Fecha", label: "Fecha", align: "left" },
  { id: "Hora", label: "Hora", align: "left" },
  { id: "TipoChecada", label: "Tipo", align: "left" },
  { id: "Nombre", label: "Nombre", align: "left" },
  { id: "Area", label: "Area o proyecto", align: "left" },
  { id: "Sede", label: "Sede", align: "left" },
  { id: "HorarioLaboral", label: "Horario Laboral", align: "left" },
  { id: "Ubicacion", label: "Ubicación", align: "left" },
  { id: "Acumulado", label: "T. trabajado", align: "left" },
  { id: "Diferencia", label: "Retardos", align: "left" },
];

/* =====================================================
   COMPONENTE PRINCIPAL
   ===================================================== */
function UserScheduleList({ idCalendar }: any) {

  const { state, dispatch } = useContext(CalendarsContext);
  const [usersClock, setUsersClock] = useState([]);
  const [valueFilter, setValueFilter] = useState("day");
  const [valueMonthNumber] = useState(format(new Date(), 'L', { locale: es }));
  const [valueMonth, setValueMonth] = useState(format(new Date(), 'MMMM', { locale: es }));
  const [valueDay] = useState(format(new Date(), 'yyyy-MM-dd', { locale: es }));
  const [month, setMonth] = useState<any>(new Date());
  const [viewColaboradoes, setViewColaboradoes] = useState(false);
  const [userFilterCombo, setUserFilerCombo] = useState<any[]>([]);
  const [sizeUsers, setSizeUser] = useState<number>();
  const [usersCheck, setUsersCheck] = useState<any[]>([]);
  const [usersFilter, setUsersFilter] = useState<any[]>([]);
  const [valueCalendarDay, setValueCalendarDay] = useState<any>();
  const [valueDateStart, setValueDateStart] = useState<any>();
  const [valueDateEnd, setValueDateEnd] = useState<any>();
  const [loading, setLoading] = useState(false);

  const [getUsersClock] = useLazyQuery(GET_TIMECHECKER_OPT, {
    fetchPolicy: 'no-cache'
  });

  /* =====================================================
     FUNCIÓN GENERAL PARA CARGAR DATOS (CON LOADER)
     ===================================================== */
  const fetchUsersClock = async (scheduleInput: any) => {
    try {
      setLoading(true);
      const response = await getUsersClock({ variables: { input: scheduleInput } });
      const data = response.data?.GET_TIMECHECKER_OPT ?? [];
      setUsersClock(data);
      setUsersFilter(data);
      setSizeUser(data.length);
    } finally {
      setLoading(false);
    }
  };

  /* =====================================================
    EFECTO INICIAL CUANDO ABRE EL MODAL
    ===================================================== */
  useEffect(() => {
    if (state.openListUserSchedule) {
      const scheduleInput = {
        option: 1,
        idCalendar: parseInt(idCalendar),
        day: valueDay,
        month: parseInt(valueMonthNumber),
        initialDay: '',
        endDay: '',
        year: 0
      };

      fetchUsersClock(scheduleInput);
    }
  }, [state.openListUserSchedule]);

  /* =====================================================
    CAMBIAR TIPO DE FILTRO (DÍA / MES / RANGO)
    ===================================================== */
  const handleChangeFilter = async (e: any) => {
    setValueFilter(e.target.value);
    setUsersFilter(usersClock);

    const valor = e.target.value;

    if (valor === "month") {
      let mes = format(new Date(), 'L', { locale: es });
      let year = format(new Date(), 'yyyy', { locale: es });

      const scheduleInput = {
        option: 3,
        idCalendar: parseInt(idCalendar),
        day: '',
        month: parseInt(mes),
        initialDay: '',
        endDay: '',
        year: parseInt(year)
      };
      await fetchUsersClock(scheduleInput);
    }

    if (valor === "day") {
      let dateCalendar = new Date();
      let dateFormatCalendar = format(dateCalendar, 'yyyy/MM/dd', { locale: es });

      setValueCalendarDay(dateFormatCalendar);

      const scheduleInput = {
        option: 1,
        idCalendar: parseInt(idCalendar),
        day: dateFormatCalendar,
        month: parseInt(valueMonthNumber),
        initialDay: '',
        endDay: '',
        year: 0
      };

      await fetchUsersClock(scheduleInput);
    }

    if (valor === "date") {
      setUsersFilter([]);
    }
  };

  /* =====================================================
    NAVEGAR HACIA ATRÁS (MES ANTERIOR)
    ===================================================== */
  const backMonth = async () => {
    const res = subMonths(month, 1);
    setMonth(res);
    setValueMonth(format(res, 'MMMM', { locale: es }));

    let mes = format(res, 'L', { locale: es });
    let year = format(new Date(), 'yyyy', { locale: es });

    const scheduleInput = {
      option: 3,
      idCalendar: parseInt(idCalendar),
      day: '',
      month: parseInt(mes),
      initialDay: '',
      endDay: '',
      year: parseInt(year)
    };

    await fetchUsersClock(scheduleInput);
  };

  /* =====================================================
    NAVEGAR HACIA ADELANTE (MES SIGUIENTE)
    ===================================================== */
  const nextMonth = async () => {
    const res = addMonths(month, 1);
    setMonth(res);
    setValueMonth(format(res, 'MMMM', { locale: es }));

    let mes = format(res, 'L', { locale: es });
    let year = format(new Date(), 'yyyy', { locale: es });

    const scheduleInput = {
      option: 3,
      idCalendar: parseInt(idCalendar),
      day: '',
      month: parseInt(mes),
      initialDay: '',
      endDay: '',
      year: parseInt(year)
    };

    await fetchUsersClock(scheduleInput);
  };

  /* =====================================================
    CLICK EN CHECKBOX DE COLABORADOR
    ===================================================== */
  const handleClickI = async (e: any, id: number) => {
    if (e.target.checked) {
      setUsersCheck([...usersCheck, id]);
    } else {
      setUsersCheck(usersCheck.filter((lis: any) => lis !== id));
    }
  };

  /* =====================================================
    FILTRAR COLABORADORES (BOTÓN GUARDAR)
    ===================================================== */
  const handleFilterUser = async () => {
    const filter = valueFilter;
    const array: any = [];

    if (filter === "day") {
      if (usersCheck.length > 0) {
        usersCheck.forEach((id) => {
          usersClock.forEach((user: any) => {
            if (user.id === id && user.Fecha === valueCalendarDay) {
              array.push(user);
            }
          });
        });
        setUsersFilter(array);
      } else {
        setUsersFilter(usersClock);
      }
    }

    if (filter === "month") {
      if (usersCheck.length > 0) {
        usersCheck.forEach((id) => {
          usersClock.forEach((user: any) => {
            if (
              user.id === id &&
              format(new Date(user.Fecha), 'MMMM', { locale: es }) ===
              format(month, 'MMMM', { locale: es })
            ) {
              array.push(user);
            }
          });
        });
        setUsersFilter(array);
      } else {
        setUsersFilter(usersClock);
      }
    }

    if (filter === "date") {
      if (usersCheck.length > 0) {
        usersCheck.forEach((id) => {
          usersClock.forEach((user: any) => {
            if (
              user.id === id &&
              (
                (isEqual(new Date(user.Fecha), new Date(valueDateStart)) ||
                  isAfter(new Date(user.Fecha), new Date(valueDateStart))) &&
                (isBefore(new Date(user.Fecha), new Date(valueDateEnd)) ||
                  isEqual(new Date(user.Fecha), new Date(valueDateEnd)))
              )
            ) {
              array.push(user);
            }
          });
        });
        setUsersFilter(array);
      } else {
        setUsersFilter(usersClock);
      }
    }

    setViewColaboradoes(false);
  };

  /* =====================================================
    CAMBIO DE FECHA (DÍA)
    ===================================================== */
  const handleFilterDate = async (e: any) => {
    let dateCalendar = addDays(new Date(e.target.value), 1);
    let dateFormatCalendar = format(dateCalendar, 'yyyy-MM-dd', { locale: es });

    const scheduleInput = {
      option: 1,
      idCalendar: parseInt(idCalendar),
      day: dateFormatCalendar,
      month: parseInt(valueMonthNumber),
      initialDay: '',
      endDay: '',
      year: 0
    };

    await fetchUsersClock(scheduleInput);
  };

  /* =====================================================
    FECHA INICIAL (RANGO)
    ===================================================== */
  const handleStartDate = async (e: any) => {
    let dateCalendar = addDays(new Date(e.target.value), 1);
    let dateFormatCalendar = format(dateCalendar, 'yyyy-MM-dd', { locale: es });
    setValueDateStart(dateFormatCalendar);

    const scheduleInput = {
      option: 2,
      idCalendar: parseInt(idCalendar),
      day: '',
      month: parseInt(valueMonthNumber),
      initialDay: dateFormatCalendar,
      endDay: valueDateEnd,
      year: 0
    };

    await fetchUsersClock(scheduleInput);
  };

  /* =====================================================
    FECHA FINAL (RANGO)
    ===================================================== */
  const handleEndDate = async (e: any) => {
    let dateCalendarEnd = addDays(new Date(e.target.value), 1);
    let dateFormatCalendarEnd = format(dateCalendarEnd, 'yyyy-MM-dd', { locale: es });
    setValueDateEnd(dateFormatCalendarEnd);

    if (!valueDateStart) {
      ErrorAlert({ text: 'Seleccione la fecha inicial' });
      return;
    }

    if (!isAfter(new Date(dateFormatCalendarEnd), new Date(valueDateStart))) {
      ErrorAlert({ text: 'La fecha inicial debe ser menor a la final' });
      return;
    }

    const scheduleInput = {
      option: 2,
      idCalendar: parseInt(idCalendar),
      day: '',
      month: parseInt(valueMonthNumber),
      initialDay: valueDateStart,
      endDay: dateFormatCalendarEnd,
      year: 0
    };

    await fetchUsersClock(scheduleInput);
  };

  /* =====================================================
    MOSTRAR / OCULTAR LISTA DE COLABORADORES
    ===================================================== */
  const handleViewColaboradores = () => {
    if (!viewColaboradoes) {
      setViewColaboradoes(true);

      if (usersClock.length && usersClock.length === sizeUsers) {
        const unique = usersClock.filter(
          (data: any, index, arr) =>
            index === arr.findIndex((t: any) => t.id === data.id)
        );

        setUserFilerCombo(
          unique.map((user: any) => ({
            id: user.id,
            nombre: user.Nombre
          }))
        );
      }
    } else {
      setViewColaboradoes(false);
    }
  };

  /* =====================================================
    FILTRAR POR NOMBRE (INPUT DE BUSQUEDA)
    ===================================================== */
  const handleUserFilter = (e: any) => {
    if (e !== '') {
      setUserFilerCombo(
        userFilterCombo.filter((lis: any) =>
          lis.nombre.toUpperCase().includes(e.toUpperCase())
        )
      );
    } else {
      let array: any[] = [];
      usersClock
        .filter(
          (data: any, index, arr) =>
            index === arr.findIndex((t: any) => t.id === data.id)
        )
        .map((user: any) => {
          array.push({ id: user.id, nombre: user.Nombre });
        });
      setUserFilerCombo(array);
    }
  };

  /* =====================================================
    DESCARGAR REPORTE (EXCEL)
    ===================================================== */
  const handleReportrelogUser = () => {
    const TipoReporte = "Reporte Registros de tiempos";

    interface Registro {
      id: number;
      Nombre: string;
      Sede: string;
      Area: string;
      HorarioLaboral: string;
      Hora: string;
      TipoChecada: "entrada" | "salida" | "descanso";
      Diferencia: number | null;
      Ubicacion: string;
      Acumulado: number | null;
      Fecha: string;
    }

    interface RegistroAgrupado {
      Nombre: string;
      Sede: string;
      Area: string;
      HorarioLaboral: string;
      Fecha: string;
      entrada: Registro | null;
      salida: Registro | null;
      descanso: Registro | null;
    }

    const agrupados = Object.values(
      usersFilter.reduce<Record<string, RegistroAgrupado>>((acc, item: any) => {
        const key = `${item.Nombre}-${item.Fecha}`;

        if (!acc[key]) {
          acc[key] = {
            Nombre: item.Nombre,
            Sede: item.Sede,
            Area: item.Area,
            HorarioLaboral: item.HorarioLaboral,
            Fecha: item.Fecha,
            entrada: null,
            salida: null,
            descanso: null,
          };
        }

        switch (item.TipoChecada) {
          case "entrada":
            const entrada = acc[key].salida;
            if (!entrada || item.Hora < entrada?.Hora) {
              acc[key].entrada = item;
            }
            break;

          case "salida":
            const salida = acc[key].salida;
            if (!salida || item.Hora > salida.Hora) {
              acc[key].salida = item;
            }
            break;

          case "descanso":
            const descansoActual = acc[key].descanso;
              if (!descansoActual || item.Hora < descansoActual.Hora) {
              acc[key].descanso = item;
            }
        break;
        }

        return acc;
      }, {})
    );

    const salidaFormateada = agrupados.map((r: RegistroAgrupado) => ({
      Nombre: r.Nombre,
      Sede: r.Sede,
      Area: r.Area,
      HorarioLaboral: r.HorarioLaboral,
      Fecha: r.Fecha,

      EntradaHora: r.entrada?.Hora || null,
      EntradaUbicacion: r.entrada?.Ubicacion || null,
      EntradaTipo: r.entrada?.TipoChecada || null,
      EntradaId: r.entrada?.id || null,

      SalidaHora: r.salida?.Hora || null,
      SalidaUbicacion: r.salida?.Ubicacion || null,
      SalidaTipo: r.salida?.TipoChecada || null,
      SalidaId: r.salida?.id || null,

      DescansoHora: r.descanso?.Hora || null,
      DescansoUbicacion: r.descanso?.Ubicacion || null,
      DescansoTipo: r.descanso?.TipoChecada || null,
      DescansoId: r.descanso?.id || null,
    }));

    CreateExcelRelogChecador(salidaFormateada, TipoReporte);
  };

  /* =====================================================
    REINICIAR ESTADOS AL CERRAR
    ===================================================== */
  const resetStates = () => {
    setUsersFilter([]);
    setUsersClock([]);
    setUserFilerCombo([]);
    setUsersCheck([]);
    setViewColaboradoes(false);
    setValueFilter('day');
    setMonth(new Date());
    setValueMonth(format(new Date(), 'MMMM', { locale: es }));
  };

  /* =====================================================
    RENDER
    ===================================================== */
  return (
    <Dialog
      open={state.openListUserSchedule}
      aria-labelledby="form-dialog-title"
      maxWidth="xl"
      fullWidth={true}
    >
      <div className="dialogContainer">
        <div className="containerTitle">
          <div className="centerContainer"></div>

          <div className="contenedorCerrarModal">
            <div
              className="iconoCerrarModal"
              onClick={() => {
                resetStates();
                closeListUserSchedule(false, dispatch);
              }}
            ></div>
          </div>
        </div>

        {/* ====================== FILTROS ====================== */}
        <div className="containerFiltroRelojChecador">
          <h2 id="form-dialog-title">Registros de tiempos</h2>

          <div className="selectFiltroCheck">
            <Select
              native
              label="filtroRelojChecador"
              name="filtroRelojChecador"
              autoFocus={true}
              onChange={(e) => handleChangeFilter(e)}
            >
              <option value="day">Mostrar listado por día</option>
              <option value="month">Mostrar listado por mes</option>
              <option value="date">Mostrar listado por fecha</option>
            </Select>
          </div>

          <div className="elementFiltro">
            {valueFilter === "day" && (
              <>
                <TextField
                  id="date"
                  variant="outlined"
                  margin="dense"
                  label="Día*"
                  type="date"
                  onChange={(e) => handleFilterDate(e)}
                  defaultValue={format(new Date(), "yyyy-MM-dd")}
                />
              </>
            )}

            {valueFilter === "month" && (
              <div className="contenedorMonth">
                <div className="backArrow">
                  <ArrowBackIosIcon onClick={() => backMonth()} />
                </div>

                <div className="infoMont">{valueMonth}</div>

                <div className="nextArrow">
                  <ArrowForwardIosIcon onClick={() => nextMonth()} />
                </div>
              </div>
            )}

            {valueFilter === "date" && (
              <>
                <div className="dateInit">
                  <TextField
                    id="dateInit"
                    variant="outlined"
                    margin="dense"
                    label="Fecha inicial*"
                    type="date"
                    onChange={(e) => handleStartDate(e)}
                    defaultValue={format(new Date(), "yyyy-MM-dd")}
                  />
                </div>

                <TextField
                  id="dateEnd"
                  variant="outlined"
                  margin="dense"
                  label="Fecha final*"
                  type="date"
                  onChange={(e) => handleEndDate(e)}
                  defaultValue={format(new Date(), "yyyy-MM-dd")}
                />
              </>
            )}
          </div>
        </div>

        {/* ================= BUSCAR COLABORADOR ================= */}
        <div className="containerFindColaborador">
          <div className="containderImputsSearcher">
            <input
              placeholder="Filtrar por Colaborador"
              className="inputSearcherColaborador"
              onChange={(e: any) => handleUserFilter(e.target.value)}
              onClick={() => handleViewColaboradores()}
            />
          </div>

          {viewColaboradoes && (
            <div>
              <div className="divColaboradoresList">
                <fieldset className="fieldsetUpdateFiltro">
                  <div className="checkboxitemColaboradores">
                    <input type="checkbox" id="erer"></input>
                    <label htmlFor="erer"></label>
                  </div>

                  <input
                    className="inputUpdateColaboradores"
                    type="text"
                    id="txtFiltro"
                    placeholder="Colaboradores"
                  />

                  <img src={`/assets/svg/find.svg`} alt="Buscar" />
                </fieldset>

                <ul className="contenedorListaColaboradoresReloj">
                  {userFilterCombo.length > 0 &&
                    userFilterCombo.map((lis: any, key: number) => (
                      <li className="listaNombresColaboradores" key={key}>
                        <div
                          id="UniversoI"
                          className="checkboxitemColaboradores"
                        >
                          <input
                            id={"Colaborador" + lis.nombre}
                            type="checkbox"
                            value={lis.id}
                            checked={usersCheck.includes(lis.id)}
                            className="colaborador"
                            onClick={(e) => handleClickI(e, lis.id)}
                          ></input>

                          <label htmlFor={"Colaborador" + lis.nombre}>
                            {" "}
                            {lis.nombre}
                          </label>
                        </div>
                      </li>
                    ))}
                </ul>

                <br />

                <div className="contenedorBtnAgregarColaborador">
                  <button
                    className="botonAgregarColaborador"
                    onClick={() => handleFilterUser()}
                  >
                    <span className="textoAgregarColaborador">Guardar</span>
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>

        {/* ====================== TABLA ====================== */}

        <DialogContent>
          {loading ? (
            <div style={{ textAlign: "center", padding: 40 }}>
              <div className="spinner"></div>
              <p>Cargando información...</p>
            </div>
          ) : (
            <TableBits
              columns={columns}
              rows={usersFilter}
              options={false}
            />
          )}
        </DialogContent>

        {/* ====================== BOTONES ====================== */}
        <div className="btnRelojChecador">
          <button
            className="botonCancelarReloj"
            type="button"
            onClick={() => {
              resetStates();
              closeListUserSchedule(false, dispatch);
            }}
          >
            Cancelar
          </button>

          <button
            className="btnDescargarLista"
            onClick={() => handleReportrelogUser()}
          >
            <span className="textoAgregarColaborador">Descargar Lista</span>
          </button>
        </div>
      </div>
    </Dialog>
  );
}

export default UserScheduleList;
